﻿/**
 * Created by GIS-2 on 7/21/2020.
 */
//import 'ol/ol.css';
//import './css/style.css';
import { Overlay } from 'ol';
import { WFS as WFSFormat, GML as GMLFormat, WKT, GeoJSON } from 'ol/format';
import { Draw, Snap, Modify, Select } from 'ol/interaction';
import { Vector as VectorSource } from 'ol/source';
import { Vector as VectorLayer } from 'ol/layer';
import { Control } from 'ol/control';
import { Circle as CircleStyle, Icon, Fill, Stroke, Style, Text } from 'ol/style.js';
//../../chart.js/dist/Chart.js
//const Draggable = require('Draggable');
const Draggable = require('../../draggable/src/draggable.js');

export { GeometryEditorTool };

/**
 * Class Identify
 */
const GeometryEditorTool = function () {

    // Define this
    var geoEditor = this;

    // Actice tool
    this._hashActiveTool = {};

    this._mapSgs = null;
    this.layer = null;
    this.vectorSource = null;
    this.drawTool = null;
    this.snapTool = null;
    this.selectTool = null;
    this.modifyTool = null;
    this.layer_name = 'test';
    this.lastID = -999999;
    this.overlayId = 0;
    this.annotations = new Array();
    this.MENU = { 'SELECT_FEATURE': 0, 'EDIT_FEATURE': 1, 'MODIFY_FEATURE': 2, 'DELETE_FEATURE': 3, 'SNAP': true, 'SELECTED': 0, 'CONTROL_VISIBLE': false };
    this.REVISION_STORE = {};

    // Geojson Format
    this._geojsonFormat = new GeoJSON();

    this._DatatableResultAnnotation = null;

    this._IdFeatureDataSelect = null;

    this._formDataSearchAnnotation= null;

    this._annotationRepeated= null;

    this._hashComment = {};

    // Style draw pipe
    this._styleDrawNote = [
        new Style({
            fill: new Fill({
                color: 'rgba(255, 255, 255, 0.1)'
            }),
            stroke: new Stroke({
                color: 'rgba(255, 255, 255, 1)',
                //lineDash: [10, 10],
                width: 8
            }),
            image: new CircleStyle({
                radius: 5,
                width: 3,
                stroke: new Stroke({
                    color: 'rgba(255, 255, 255, 1)'
                }),
                fill: new Fill({
                    color: 'rgba(255, 255, 255, 0.1)'
                })
            })
        }),
        new Style({
            stroke: new Stroke({
                color: 'rgba(252, 3, 3, 1)',
                //lineDash: [10, 10],
                width: 4
            }),
            image: new CircleStyle({
                radius: 4,
                width: 2,
                stroke: new Stroke({
                    color: 'rgba(252, 3, 3, 1)'
                }),
                fill: new Fill({
                    color: 'rgba(255, 255, 255, 0.1)'
                })
            })
        })
    ];

    this.initialize = function () {

        
        
        //this._mapSgs.map.addControl(new this.PointFeatureTool());
        //this._mapSgs.map.addControl(new this.LineFeatureTool());
        //this._mapSgs.map.addControl(new this.PolygonFeatureTool());
        //this._mapSgs.map.addControl(new this.ModifyFeatureTool());
        //this._mapSgs.map.addControl(new this.DeleteFeatureTool());
        //this._mapSgs.map.addControl(new this.AnnotationFeatureTool());
        //this._mapSgs.map.addControl(new this.SnapFeatureTool());
        //this._mapSgs.map.addControl(new this.DeleteVertexTool());



        geoEditor.vectorSource = new VectorSource({});

        geoEditor.layer = new VectorLayer({
            source: geoEditor.vectorSource,
            style: this._styleDrawNote
        });

        geoEditor._mapSgs.map.addLayer(geoEditor.layer);
        geoEditor.selectTool = new Select();

        geoEditor.hideControls();

        $('#button-open-geometry-editor-tool').click(function () {
            geoEditor.CONTROL_VISIBLE = !geoEditor.CONTROL_VISIBLE;
            if (geoEditor.CONTROL_VISIBLE) {
                geoEditor.showControls();
            } else {
                geoEditor.hideControls();
            }

            if ($('#id-map-title-geometry-load').is(':Visible')) {
                $('#id-map-title-geometry-load').css('display', 'none');
            } else if ($('#id-map-title-geometry-load').hasClass('active')) {
                $('#id-map-title-geometry-load').css('display', 'block');
            }
        });

        $('#id-modal-geometry-editor-tool-submit').on('click', function () {

            var featuresData = geoEditor._geojsonFormat.writeFeatures(geoEditor.layer.getSource().getFeatures())

            geoEditor._formDataSearchAnnotation = $('#id-modal-geometry-editor-tool-form').serializeJSON();

            geoEditor._formDataSearchAnnotation.geojson = featuresData;

            geoEditor._formDataSearchAnnotation.idUser =  geoEditor._mapSgs._settings.userInfo.userId

            if (geoEditor._DatatableResultAnnotation) {

                var RowData = geoEditor._DatatableResultAnnotation.rows('.selected').data();

                if (RowData.length > 0)
                    geoEditor._formDataSearchAnnotation.id = RowData[0].id;

            }

            if (geoEditor._formDataSearchAnnotation.name === "") {
                return toastr["warning"]("Obrigatório preencher o nome");
            }

            if (geoEditor._annotationRepeated == true) {

                var confReplacement = confirm("Deseja substituir a anotação existente?");

                if (confReplacement == true) {
                    geoEditor._formDataSearchAnnotation.repeated = "true";

                } else {
                    geoEditor._annotationRepeated = false;
                    return;
                }

            }

            var CommentObject = {};

            $.each(geoEditor._hashComment, function (key, value) {

                if ($('#' + value.id).html() != null && $('#' + value.id).html() != "") {

                    geoEditor._hashComment[key].text = $('#' + value.id).html();

                    CommentObject[key] = geoEditor._hashComment[key];

                }

            });

            geoEditor._formDataSearchAnnotation.Overlay = JSON.stringify(CommentObject);

            $.ajax({
                type: 'POST',
                url: '/rest/app/Service/PostMapAnnotation?userID=' + geoEditor._mapSgs._settings.userInfo.userId,
                data: JSON.stringify(geoEditor._formDataSearchAnnotation),
                contentType: "application/json",
                success: function (data) {

                    if (data.result === "NotUser") {

                        toastr.options.timeOut = "5000";
                        var warning = toastr["warning"]("Apenas o utilizador que cria a anotação pode editar a mesma");
                        toastr.options.timeOut = "2000";
                        return warning

                    }

                    if (data.result === 'repeated') {

                        geoEditor._annotationRepeated = true;
                        return $('#id-modal-geometry-editor-tool-submit').trigger('click');

                    } else {

                        if ($('#id-map-title-geometry-load').length > 0) {

                            $('#id-map-title-geometry-load').css('display', 'block');
                            $('#id-map-title-geometry-load')[0].innerHTML = 'Anotação carregada: ' + $('#id-modal-geometry-editor-tool-name').val();
                            geoEditor._IdFeatureDataSelect = data.result;

                        } else if ($('#id-map-title-geometry-load').length == 0) {

                            $('#map').append('<div id="id-map-title-geometry-load" class="div-name-geometry-editor-load active">Anotação carregada: ' + $('#id-modal-geometry-editor-tool-name').val() + '</div>')

                            geoEditor._IdFeatureDataSelect = data.result;

                        }

                        if (geoEditor._mapSgs._utility.mobilecheck()) {
                            $('.div-name-geometry-editor-load').css('bottom', '130px');
                        }

                        geoEditor._annotationRepeated = false;

                        $('#id-icon-change-load').addClass('ol-hidden');

                        $('#id-buttoneg-delete-load').removeClass('hide-delete-button');

                        $('#id-modal-geometry-editor-tool').modal('hide');

                        toastr["success"]("Gravação realizada com sucesso");
                    }
                    
                },
                error: function (request, status, error) {
                    toastr["error"]("Erro na gravação");
                    myMapSgs._utility.ShowWait('offcanvas-entity-form-spinner', false);
                }
            });

        });

        $('#id-modal-geometry-editor-tool-close').on('click', function () {

            $('#id-modal-geometry-editor-tool').modal('hide');

        });

        $('#id-modal-geometry-editor-tool-load-close').on('click', function () {

            $('#id-modal-geometry-editor-tool-load').modal('hide');

        });

        $('#id-modal-geometry-editor-tool-load-submit').on('click', function () {

            geoEditor._CleanAllAnnotation();

            var RowData = geoEditor._DatatableResultAnnotation.rows('.selected').data();

            if (RowData.length > 0) {

                var HashComment = JSON.parse(RowData[0].overlay);

                $.each(HashComment, function (key, value) {

                    geoEditor.buildComment(value.coord, value.id);

                    $('#' + value.id).html(value.text);

                    geoEditor.overlayId++

                    $("#" + value.id).css({ 'inset': '' });

                });

                var featuresData = geoEditor._geojsonFormat.readFeatures(RowData[0].geojson)

                geoEditor.layer.getSource().addFeatures(featuresData)

                geoEditor._mapSgs.map.getView().fit(geoEditor.layer.getSource().getExtent(), { size: geoEditor._mapSgs.map.getSize(), maxZoom: 12, duration: 1000 });

                $('#id-modal-geometry-editor-tool-load').modal('hide');

                $('#id-map-title-geometry-load').remove();

                $('#map').append('<div id="id-map-title-geometry-load" class="div-name-geometry-editor-load active">Anotação carregada: ' + RowData[0].name + '</div>');

                $('#id-buttoneg-delete-load').removeClass('hide-delete-button');

                if (geoEditor._mapSgs._utility.mobilecheck()) {
                    $('.div-name-geometry-editor-load').css('bottom', '130px');
                }

                geoEditor._IdFeatureDataSelect = RowData[0].id;

                $('#id-icon-change-load').addClass('ol-hidden');

            }

        });

    };
    
    this.addInteractions = function (type) {
        geoEditor.drawTool = new Draw({
            source: geoEditor.vectorSource,
            type: type,
            style: this._styleDrawNote,
            condition: function (event) {

                return true;
            }
        });
        geoEditor.drawTool.on("drawstart", function (event) {

            const feature = event.feature;
            geoEditor.lastID++;
            feature.setId(geoEditor.layer_name + '.' + geoEditor.lastID);
        });
        geoEditor.drawTool.on('drawend', function (event) {

            const feature = event.feature;
            geoEditor.REVISION_STORE[feature.getId().toString()] = feature.getRevision();
            
            $('#id-icon-change-load').removeClass('ol-hidden');
        });


        geoEditor._mapSgs.map.addInteraction(geoEditor.drawTool);

        if (geoEditor.MENU.SNAP) {
            geoEditor.snapTool = new Snap({ source: geoEditor.vectorSource });
            geoEditor._mapSgs.map.addInteraction(geoEditor.snapTool);
        } else {
            geoEditor._mapSgs.map.removeInteraction(geoEditor.snapTool);
        }
    };

    this.removeInteractions = function () {
        geoEditor._mapSgs.map.removeInteraction(geoEditor.snapTool);
        geoEditor._mapSgs.map.removeInteraction(geoEditor.drawTool);
        geoEditor._mapSgs.map.removeInteraction(geoEditor.selectTool);
        geoEditor._mapSgs.map.removeInteraction(geoEditor.modifyTool);
    };

    this.SelectFeatureTool = (function (Control) {
        function SelectFeatureTool(opt_options) {
            const options = opt_options || {};

            const button = document.createElement('button');
            //button.innerHTML = '<i class="fa fa-map-pin" aria-hidden="true"></i>';
            button.innerHTML = '<i class="fa fa-map-pin" aria-hidden="true"></i>';

            const element = document.createElement('div');

            element.setAttribute('id', 'editor_select');
            element.setAttribute('ref', 'select');
            element.className = 'select ol-unselectable ol-control';
            element.appendChild(button);


            Control.call(this, {
                element: element,
                target: options.target
            });

            button.addEventListener('click', this.handleSelectFeature.bind(this), false);
        }

        if (Control) {
            SelectFeatureTool.__proto__ = Control;
        }
        SelectFeatureTool.prototype = Object.create(Control && Control.prototype);
        SelectFeatureTool.prototype.constructor = SelectFeatureTool;

        SelectFeatureTool.prototype.handleSelectFeature = function handleAddFeature() {
            geoEditor.MENU.SELECTED = geoEditor.MENU.SELECT_FEATURE;
            geoEditor.removeInteractions();
            if (!(typeof geoEditor._mapSgs.map.listeners_.click == 'undefined')) {
                if (geoEditor._mapSgs.map.listeners_.click.length > 0) {
                    geoEditor._mapSgs.map.listeners_.click = new Array();
                }
            }
            geoEditor._mapSgs.map.addInteraction(geoEditor.selectTool);

        };

        return SelectFeatureTool;
    }(Control));

    this.createDatatable = (function (IdDatatable) {

        // -- init column def --
        var columnDefResultAnnotation = [];

        columnDefResultAnnotation.push({
            'data': 'id',
            'type': 'readonly',
            'visible': false
        });

        // name
        columnDefResultAnnotation.push({
            'id': 'name_result_annotation',
            'data': 'name',
            'type': 'readonly',
        });

        // observation
        columnDefResultAnnotation.push({
            'id': 'observation_result_annotation',
            'data': 'observation',
            'type': 'readonly',
        });

        // date
        columnDefResultAnnotation.push({
            'id': 'description_result_annotation',
            'data': 'date',
            'type': 'readonly',
            'render': function (data, type, row) {
                if (data) {
                    return geoEditor._mapSgs._utility.TransformDateServerInDateTime(data);
                }
            }
        });

        geoEditor._DatatableResultAnnotation = $('#' + IdDatatable).DataTable({
            "destroy": true,
            "language": {
                "search": "Procurar",
                "emptyTable": 'Nenhuma anotação encontrada',
                "paginate": {
                    "previous": '<i class="fa fa-caret-left"></i>',
                    "next": '<i class="fa fa-caret-right"></i>',
                    "first": '<i class="fa fa-step-backward"></i>',
                    "last": '<i class="fa fa-step-forward"></i>'
                }
            },
            "fixedHeader": false,
            "filter": true,
            "info": false,
            "scrollCollapse": true,
            "deferRender": false,
            "scroller": false,
            "ordering": false,
            "columns": columnDefResultAnnotation,
            "select": true,
            "bPaginate": true,
            "name": "LayerSource_style",
            "rowId": 'id',
            "searchable": true,
            "lengthChange": false,
            "scrollX": true,
            "scrollY": "300px",
            "autoWidth": true,
            "iDisplayLength": 5
        });

    });

    this.ModifyFeatureTool = (function (Control) {
        function ModifyFeatureTool(opt_options) {
            const options = opt_options || {};

            const button = document.createElement('button');
            button.innerHTML = '<i class="fa fa-edit" aria-hidden="true">';

            const element = document.createElement('div');

            element.setAttribute('id', 'editor_modify');
            element.setAttribute('ref', 'modify');
            element.className = 'modify ol-unselectable ol-control';
            element.appendChild(button);

            Control.call(this, {
                element: element,
                target: options.target
            });

            button.addEventListener('click', this.handleModifyFeature.bind(this), false);
        }

        if (Control) {
            ModifyFeatureTool.__proto__ = Control;
        }
        ModifyFeatureTool.prototype = Object.create(Control && Control.prototype);
        ModifyFeatureTool.prototype.constructor = ModifyFeatureTool;

        ModifyFeatureTool.prototype.handleModifyFeature = function handleModifyFeature() {
            geoEditor.MENU.SELECTED = geoEditor.MENU.MODIFY_FEATURE;
            geoEditor.removeInteractions();
            if (!(typeof geoEditor._mapSgs.map.listeners_.click == 'undefined')) {
                if (geoEditor._mapSgs.map.listeners_.click.length > 0) {
                    geoEditor._mapSgs.map.listeners_.click = new Array();
                }
            }

            geoEditor.modifyTool = new Modify(
                {
                    source: geoEditor.vectorSource,
                    insertVertexCondition: function (event) {
                        return true;
                    },
                    condition: function (event) {

                        return true;
                    }
                });


            geoEditor.modifyTool.on('modifystart', function (event) {

            });

            geoEditor.modifyTool.on('modifyend', function (event) {
                const modifyFeatures = event.features.array_;
                let modifiedFeature = null;
                for (let i = 0; i < modifyFeatures.length; i++) {
                    const f = modifyFeatures[i];
                    if (geoEditor.REVISION_STORE[f.getId().toString()] != f.getRevision()) {
                        geoEditor.REVISION_STORE[f.getId().toString()] = f.getRevision();
                        modifiedFeature = f;
                        break;
                    }
                }

            });

            geoEditor._mapSgs.map.addInteraction(geoEditor.modifyTool);
            if (geoEditor.MENU.SNAP) {
                geoEditor.snapTool = new Snap({ source: geoEditor.vectorSource });
                geoEditor._mapSgs.map.addInteraction(geoEditor.snapTool);
            } else {
                geoEditor._mapSgs.map.removeInteraction(geoEditor.snapTool);
            }
        };
        return ModifyFeatureTool;
    }(Control));

    this.DeleteVertexTool = (function (Control) {
        function DeleteVertexTool(opt_options) {
            const options = opt_options || {};

            const button = document.createElement('button');
            button.innerHTML = '<i class="fa fa-times-circle" aria-hidden="true">';

            const element = document.createElement('div');
            element.setAttribute('id', 'editor_delete-vertex-feature');
            element.setAttribute('ref', 'delete-vertex-feature');
            element.className = 'delete-vertex-feature ol-unselectable ol-control';
            element.appendChild(button);

            Control.call(this, {
                element: element,
                target: options.target
            });

            button.addEventListener('click', this.handleDeleteVertex.bind(this), false);
        }

        if (Control) {
            DeleteVertexTool.__proto__ = Control;
        }
        DeleteVertexTool.prototype = Object.create(Control && Control.prototype);
        DeleteVertexTool.prototype.constructor = DeleteVertexTool;

        DeleteVertexTool.prototype.handleDeleteVertex = function handleDeleteVertex() {

            geoEditor.removeInteractions();
            if (!(typeof geoEditor._mapSgs.map.listeners_.click === 'undefined')) {
                if (geoEditor._mapSgs.map.listeners_.click.length > 0) {
                    geoEditor._mapSgs.map.listeners_.click = new Array();
                }
            }

            geoEditor.modifyTool = new Modify(
                {
                    source: geoEditor.vectorSource,
                    insertVertexCondition: function (event) {
                        return true;
                    },
                    condition: function (event) {

                        return true;
                    }
                });
            geoEditor._mapSgs.map.addInteraction(geoEditor.modifyTool);
            if (geoEditor.MENU.SNAP) {
                geoEditor.snapTool = new Snap({ source: geoEditor.vectorSource });
                geoEditor._mapSgs.map.addInteraction(geoEditor.snapTool);
            } else {
                geoEditor._mapSgs.map.removeInteraction(geoEditor.snapTool);
            }

            geoEditor._mapSgs.map.on('click', function (event) {
                geoEditor._mapSgs.map.forEachFeatureAtPixel(event.pixel, function (feature, layer) {
                    geoEditor.modifyTool.removePoint();
                });
            });
        };

        return DeleteVertexTool;
    }(Control));

    this.DeleteFeatureTool = (function (Control) {
        function DeleteFeatureTool(opt_options) {
            const options = opt_options || {};

            const button = document.createElement('button');
            button.innerHTML = '<i class="fa fa-trash-alt" aria-hidden="true">';

            const element = document.createElement('div');
            element.setAttribute('id', 'editor_delete');
            element.setAttribute('ref', 'delete');
            element.className = 'delete ol-unselectable ol-control';
            element.appendChild(button);

            Control.call(this, {
                element: element,
                target: options.target
            });

            button.addEventListener('click', this.handleDeleteFeature.bind(this), false);
        }

        if (Control) {
            DeleteFeatureTool.__proto__ = Control;
        }
        DeleteFeatureTool.prototype = Object.create(Control && Control.prototype);
        DeleteFeatureTool.prototype.constructor = DeleteFeatureTool;

        DeleteFeatureTool.prototype.handleDeleteFeature = function handleDeleteFeature() {

            geoEditor.MENU.SELECTED = geoEditor.MENU.DELETE_FEATURE;
            geoEditor.removeInteractions();

            if (!(typeof geoEditor._mapSgs.map.listeners_.click === 'undefined')) {
                if (geoEditor._mapSgs.map.listeners_.click.length > 0) {
                    geoEditor._mapSgs.map.listeners_.click = new Array();
                }
            }

            geoEditor._mapSgs.map.on('click', function (evt) {
                this.forEachFeatureAtPixel(evt.pixel,
                    function (feature, layer) {
                        if (layer == null) {
                            return;
                        }
                        if (layer.getSource() == null) {
                            return;
                        }
                        layer.getSource().removeFeature(feature);
                                               
                        return true;
                    });
            });

        };

        return DeleteFeatureTool;

    }(Control));

    this.AnnotationFeatureTool = (function (Control) {
        function AnnotationFeatureTool(opt_options) {
            const options = opt_options || {};

            const button = document.createElement('button');
            button.innerHTML = '<i class="fa fa-comment-dots" aria-hidden="true">';
            
            const element = document.createElement('div');
            element.setAttribute('id', 'editor_annotation');
            element.setAttribute('ref', 'annotation');
            element.className = 'annotation ol-unselectable ol-control';
            element.appendChild(button);

            Control.call(this, {
                element: element,
                target: options.target
            });

            button.addEventListener('click', this.handleAnnonationFeature.bind(this), false);
        }

        if (Control) {
            AnnotationFeatureTool.__proto__ = Control;
        }
        AnnotationFeatureTool.prototype = Object.create(Control && Control.prototype);
        AnnotationFeatureTool.prototype.constructor = AnnotationFeatureTool;

        AnnotationFeatureTool.prototype.handleAnnonationFeature = function handleAnnonationFeature() {

            geoEditor.MENU.SELECTED = geoEditor.MENU.EDIT_FEATURE;
            geoEditor.removeInteractions();

            if (!(typeof geoEditor._mapSgs.map.listeners_.click == 'undefined')) {
                if (geoEditor._mapSgs.map.listeners_.click.length > 0) {
                    geoEditor._mapSgs.map.listeners_.click = new Array();
                }
            }

            geoEditor._mapSgs.map.on('click', function (evt) {
                geoEditor.addComment(evt);
                geoEditor._mapSgs.map.un('click');

            });
        };

        return AnnotationFeatureTool;
    }(Control));

    this.SnapFeatureTool = (function (Control) {
        function SnapFeatureTool(opt_options) {
            const options = opt_options || {};

            const button = document.createElement('button');
            button.innerHTML = '<i class="fa fa-deaf" aria-hidden="true">';
            
            const element = document.createElement('div');
            element.setAttribute('id', 'editor_snap');
            element.setAttribute('ref', 'snap');
            element.className = 'snap ol-unselectable ol-control';
            element.appendChild(button);

            Control.call(this, {
                element: element,
                target: options.target
            });

            button.addEventListener('click', this.handleSnapFeature.bind(this), false);
        }

        if (Control) {
            SnapFeatureTool.__proto__ = Control;
        }
        SnapFeatureTool.prototype = Object.create(Control && Control.prototype);
        SnapFeatureTool.prototype.constructor = SnapFeatureTool;
        SnapFeatureTool.prototype.handleSnapFeature = function handleSnapFeature() {

            geoEditor.MENU.SNAP = !geoEditor.MENU.SNAP;
            if (geoEditor.MENU.SNAP) {
                geoEditor.snapTool = new Snap({ source: geoEditor.vectorSource });
                geoEditor._mapSgs.map.addInteraction(geoEditor.snapTool);
            } else {
                geoEditor._mapSgs.map.removeInteraction(geoEditor.snapTool);
            }
        };
        return SnapFeatureTool;
    }(Control));

    this.buildComment = function (annoCoord, annoId) {

        geoEditor._hashComment[annoId.split('-')[1]] = {
            id: annoId,
            coord: annoCoord
        }

        const anno = document.createElement('div');
        anno.setAttribute('contenteditable', 'true');
        anno.id = annoId;
        anno.className = 'ol-popup anno-popup popup-responsive';
        const popup = new Overlay({
            id: annoId,
            element: anno,
            autoPan: true,
            autoPanAnimation: {
                duration: 250
            }
        });
        geoEditor._mapSgs.map.addOverlay(popup);
        popup.setPosition(annoCoord);
        geoEditor.annotations.push(popup);

        let startCoordinate;
        let endCoordinate;

        $('#' + annoId).click(function () {
            if (geoEditor.MENU.SELECTED == geoEditor.MENU.DELETE_FEATURE) {

                geoEditor.overlayId = 0;

                for (let i = 0; i < geoEditor.annotations.length; i++) {
                    const annonation = geoEditor.annotations[i];
                    if (annonation.getId() == annoId) {
                        geoEditor._mapSgs.map.removeOverlay(annonation);
                        geoEditor.annotations.splice(i, 1);
                        

                        $('#id-icon-change-load').removeClass('ol-hidden');

                        break;
                    }
                }
            }
        });
        const element = document.getElementById(annoId);


        const options = {
            onDragStart: function (element, x, y, event) {

                startCoordinate = geoEditor._mapSgs.map.getCoordinateFromPixel([x, y]);

            },
            onDragEnd: function (element, x, y, event) {
                $('#' + annoId).css('top', '').css('left', '').css('right', '').css('bottom', '');
                endCoordinate = geoEditor._mapSgs.map.getCoordinateFromPixel([x, y]);
                for (let i = 0; i < geoEditor.annotations.length; i++) {
                    const annotation = geoEditor.annotations[i];
                    if (annotation.getId() == annoId) {
                        const deltaX = (endCoordinate[0] - startCoordinate[0]);
                        const deltaY = (endCoordinate[1] - startCoordinate[1]);

                        const previousPosition = annotation.getPosition();
                        const currentPosition = [previousPosition[0] + deltaX, previousPosition[1] + deltaY];

                        geoEditor._hashComment[annoId.split('-')[1]] = {
                            id: annoId,
                            coord: currentPosition
                        }

                        $('#id-icon-change-load').removeClass('ol-hidden');

                        annotation.setPosition(currentPosition);
                    }
                }
            }
        };
        new Draggable(element, options);

    }

    this.addComment = function (evt) {

        geoEditor.overlayId = 0;

        $.each(geoEditor._hashComment, function (key, value) {

            geoEditor.overlayId = parseInt(key);

        });

        const annoCoord = evt.coordinate;

        geoEditor.overlayId++

        const annoId = 'comment-' + geoEditor.overlayId;

        geoEditor.buildComment(annoCoord, annoId);
        
    };

    this.showControls = function () {
        for (let i = 0; i < geoEditor._mapSgs.map.getControls().getLength(); i++) {
            const control = geoEditor._mapSgs.map.getControls().item(i);
            const element = control.element;
            if (element.id.includes('editor')) {
                element.style.display = 'block';
            }
        }
    };

    this.hideControls = function () {
        geoEditor.removeInteractions();
        for (let i = 0; i < geoEditor._mapSgs.map.getControls().getLength(); i++) {
            const control = geoEditor._mapSgs.map.getControls().item(i);
            const element = control.element;
            if (element.id.includes('editor')) {
                element.style.display = 'none';
            }
        }
    };

    /**
     * Clean select
     */
    this._CleanSelect = function () {
        if (myRoadBuilderTool._select) {
            myRoadBuilderTool._select.setMap(undefined);
            if (myRoadBuilderTool._select.getActive()) {
                myRoadBuilderTool._ActiveSelectRoad();
            }
        }
        $('#offcanvas-info').removeClass('show');
        $('#offcanvas-rbt-info').removeClass('show');
    }

    /**
     * Actice police draw tool
     * @param {dom} element, node element of the button (li)
     * @param {boolean} active, true active tool otherwise desactive 
     */
    this._ActicePoliceDrawTool = function (element, active) {

        // Clear Info feature
        $('#offcanvas-info').removeClass('show');

        // Desactice tool
        if (!active) {
            $(element).removeClass('active');
            $(element).find('a').removeClass('hold-button');

            // Reset cursor
            document.body.style.cursor = 'default';

            // Active tooltip
            if (geoEditor._mapSgs.tooltips)
                geoEditor._mapSgs.map.on('singleclick', async (e) => { await geoEditor._mapSgs.tooltips.BuildInfoTooltips(e); });

            // Hide submit button
            $('#target-gpi-submit-road-builder-tool').hide("slide");
        }
        else {
            // Active tool
            $(element).addClass('active');

            // Set cursor
            document.body.style.cursor = 'crosshair';

            // Desactive interaction
            if (geoEditor._mapSgs.tooltips)
                geoEditor._mapSgs.map.un('singleclick', geoEditor._mapSgs.tooltips.BuildInfoTooltips);

            // Show button submit
            $('#target-gpi-submit-road-builder-tool').show("slide");
        }

        // Register active tool
        geoEditor._hashActiveTool.drawPoliceNumber = {
            active: active,
            node: element
        }
    }

    /**
     * Menu definition
     */
    this.BuildMenuBar = function () {
        
        // -- Draw point -------------------------------------------------------------
        const buttonDrawPointGeometryEditorTool = document.createElement('li');

        const buttonDrawPointGeometryEditorToolContainer = document.createElement('a');
        buttonDrawPointGeometryEditorToolContainer.setAttribute('href', '#target-gpi-eg-draw-point');
        buttonDrawPointGeometryEditorToolContainer.id = 'target-gpi-eg-draw-point';
        buttonDrawPointGeometryEditorToolContainer.className = 'target';
        buttonDrawPointGeometryEditorToolContainer.setAttribute('title', 'Desenhar ponto');

        const buttonDrawPointGeometryEditorToolContent = document.createElement('div');
        buttonDrawPointGeometryEditorToolContent.className = 'menu-icon';
        buttonDrawPointGeometryEditorToolContent.innerHTML = '<i class="gpi gpi-ponto"></i>';

        buttonDrawPointGeometryEditorToolContainer.appendChild(buttonDrawPointGeometryEditorToolContent);
        buttonDrawPointGeometryEditorTool.appendChild(buttonDrawPointGeometryEditorToolContainer);

        /**
         * Draw point
         */
        const handlebuttonDrawPointGeometryEditorToolContent = function () {

            if (geoEditor._hashActiveTool.geometryEditorToolSelect && this == geoEditor._hashActiveTool.geometryEditorToolSelect.node) {

                geoEditor._ActiveSelectTool(geoEditor._hashActiveTool.geometryEditorToolSelect.node, false);

                geoEditor.removeInteractions();

                geoEditor._hashActiveTool.geometryEditorToolSelect = {}

            } else {

                // Desactive select tool if active
                if (geoEditor._hashActiveTool.geometryEditorToolSelect && geoEditor._hashActiveTool.geometryEditorToolSelect.active)
                    geoEditor._ActiveSelectTool(geoEditor._hashActiveTool.geometryEditorToolSelect.node, false);

                geoEditor._mapSgs._utility.HoldButtonEffect('menubar-bottom-geometry-editor-tool', 'target-gpi-eg-draw-point');
                //geoEditor._mapSgs._utility.RemoveActiveButtonInMenu('menubar-bottom-geometry-editor-tool', 'target-gpi-eg-draw-point');

                if ($(this).hasClass('active'))
                    geoEditor._ActicePoliceDrawTool(this, false);
                else
                    geoEditor._ActicePoliceDrawTool(this, true);

                // Register active tool
                geoEditor._hashActiveTool.geometryEditorToolSelect = {
                    active: $(this).hasClass('active'),
                    node: this
                }

                geoEditor.MENU.SELECTED = geoEditor.MENU.EDIT_FEATURE;
                geoEditor.removeInteractions();
                if (!(typeof geoEditor._mapSgs.map.listeners_.click == 'undefined')) {
                    if (geoEditor._mapSgs.map.listeners_.click.length > 0) {
                        geoEditor._mapSgs.map.listeners_.click = new Array();
                    }
                }
                geoEditor.addInteractions('Point');
            }

        };

        buttonDrawPointGeometryEditorTool.addEventListener('click', handlebuttonDrawPointGeometryEditorToolContent, false);
        
        // -- Draw polygon -------------------------------------------------------------

        const buttonDrawPolygonGeometryEditorTool = document.createElement('li');

        const buttonDrawPolygonGeometryEditorToolContainer = document.createElement('a');
        buttonDrawPolygonGeometryEditorToolContainer.setAttribute('href', '#target-gpi-eg-draw-polygon');
        buttonDrawPolygonGeometryEditorToolContainer.id = 'target-gpi-eg-draw-polygon';
        buttonDrawPolygonGeometryEditorToolContainer.className = 'target';
        buttonDrawPolygonGeometryEditorToolContainer.setAttribute('title', 'Desenhar polígono');

        const buttonDrawPolygonGeometryEditorToolContent = document.createElement('div');
        buttonDrawPolygonGeometryEditorToolContent.className = 'menu-icon';
        buttonDrawPolygonGeometryEditorToolContent.innerHTML = '<i class="gpi gpi-poligono"></i>';

        buttonDrawPolygonGeometryEditorToolContainer.appendChild(buttonDrawPolygonGeometryEditorToolContent);
        buttonDrawPolygonGeometryEditorTool.appendChild(buttonDrawPolygonGeometryEditorToolContainer);

        /**
         * Draw polygon handle
         */
        const handlebuttonDrawPolygonGeometryEditorTool = function () {

            if (geoEditor._hashActiveTool.geometryEditorToolSelect && this == geoEditor._hashActiveTool.geometryEditorToolSelect.node) {

                geoEditor._ActiveSelectTool(geoEditor._hashActiveTool.geometryEditorToolSelect.node, false);

                geoEditor.removeInteractions();

                geoEditor._hashActiveTool.geometryEditorToolSelect = {}

            } else {

                // Desactive select tool if active
                if (geoEditor._hashActiveTool.geometryEditorToolSelect && geoEditor._hashActiveTool.geometryEditorToolSelect.active)
                    geoEditor._ActiveSelectTool(geoEditor._hashActiveTool.geometryEditorToolSelect.node, false);

                geoEditor._mapSgs._utility.HoldButtonEffect('menubar-bottom-geometry-editor-tool', 'target-gpi-eg-draw-polygon');
                //geoEditor._mapSgs._utility.RemoveActiveButtonInMenu('menubar-bottom-geometry-editor-tool', 'target-gpi-eg-draw-polygon');

                if ($(this).hasClass('active'))
                    geoEditor._ActicePoliceDrawTool(this, false);
                else
                    geoEditor._ActicePoliceDrawTool(this, true);

                // Register active tool
                geoEditor._hashActiveTool.geometryEditorToolSelect = {
                    active: $(this).hasClass('active'),
                    node: this
                }

                geoEditor.MENU.SELECTED = geoEditor.MENU.EDIT_FEATURE;
                geoEditor.removeInteractions();
                if (!(typeof geoEditor._mapSgs.map.listeners_.click == 'undefined')) {
                    if (geoEditor._mapSgs.map.listeners_.click.length > 0) {
                        geoEditor._mapSgs.map.listeners_.click = new Array();
                    }
                }
                geoEditor.addInteractions('Polygon');
            }

        };

        buttonDrawPolygonGeometryEditorTool.addEventListener('click', handlebuttonDrawPolygonGeometryEditorTool, false);
        
        // -- Draw Line -------------------------------------------------------------

        const buttonDrawLineGeometryEditorTool = document.createElement('li');

        const buttonDrawLineGeometryEditorToolContainer = document.createElement('a');
        buttonDrawLineGeometryEditorToolContainer.setAttribute('href', '#target-gpi-eg-draw-line');
        buttonDrawLineGeometryEditorToolContainer.id = 'target-gpi-eg-draw-line';
        buttonDrawLineGeometryEditorToolContainer.className = 'target';
        buttonDrawLineGeometryEditorToolContainer.setAttribute('title', 'Desenhar linha');

        const buttonDrawLineGeometryEditorToolContent = document.createElement('div');
        buttonDrawLineGeometryEditorToolContent.className = 'menu-icon';
        buttonDrawLineGeometryEditorToolContent.innerHTML = '<i class="gpi gpi-linha"></i>';

        buttonDrawLineGeometryEditorToolContainer.appendChild(buttonDrawLineGeometryEditorToolContent);
        buttonDrawLineGeometryEditorTool.appendChild(buttonDrawLineGeometryEditorToolContainer);

        /**
         * Draw Line handle
         */
        const handlebuttonDrawLineGeometryEditorTool = function () {

            if (geoEditor._hashActiveTool.geometryEditorToolSelect && this == geoEditor._hashActiveTool.geometryEditorToolSelect.node) {

                geoEditor._ActiveSelectTool(geoEditor._hashActiveTool.geometryEditorToolSelect.node, false);

                geoEditor.removeInteractions();

                geoEditor._hashActiveTool.geometryEditorToolSelect = {}

            } else {

                // Desactive select tool if active
                if (geoEditor._hashActiveTool.geometryEditorToolSelect && geoEditor._hashActiveTool.geometryEditorToolSelect.active)
                    geoEditor._ActiveSelectTool(geoEditor._hashActiveTool.geometryEditorToolSelect.node, false);

                geoEditor._mapSgs._utility.HoldButtonEffect('menubar-bottom-geometry-editor-tool', 'target-gpi-eg-draw-line');
                //geoEditor._mapSgs._utility.RemoveActiveButtonInMenu('menubar-bottom-geometry-editor-tool', 'target-gpi-eg-draw-line');

                if ($(this).hasClass('active'))
                    geoEditor._ActicePoliceDrawTool(this, false);
                else
                    geoEditor._ActicePoliceDrawTool(this, true);

                // Register active tool
                geoEditor._hashActiveTool.geometryEditorToolSelect = {
                    active: $(this).hasClass('active'),
                    node: this
                }

                geoEditor.MENU.SELECTED = geoEditor.MENU.EDIT_FEATURE;
                geoEditor.removeInteractions();
                if (!(typeof geoEditor._mapSgs.map.listeners_.click == 'undefined')) {
                    if (geoEditor._mapSgs.map.listeners_.click.length > 0) {
                        geoEditor._mapSgs.map.listeners_.click = new Array();
                    }
                }
                geoEditor.addInteractions('LineString');
            }
        };

        buttonDrawLineGeometryEditorTool.addEventListener('click', handlebuttonDrawLineGeometryEditorTool, false);
        
        // -- Draw note -------------------------------------------------------------

        const buttonDrawNoteGeometryEditorTool = document.createElement('li');

        const buttonDrawNoteGeometryEditorToolContainer = document.createElement('a');
        buttonDrawNoteGeometryEditorToolContainer.setAttribute('href', '#target-gpi-eg-draw-note');
        buttonDrawNoteGeometryEditorToolContainer.id = 'target-gpi-eg-draw-note';
        buttonDrawNoteGeometryEditorToolContainer.className = 'target';
        buttonDrawNoteGeometryEditorToolContainer.setAttribute('title', 'Desenhar nota');

        const buttonDrawNoteGeometryEditorToolContent = document.createElement('div');
        buttonDrawNoteGeometryEditorToolContent.className = 'menu-icon';
        buttonDrawNoteGeometryEditorToolContent.innerHTML = '<i class="material-icons" style="margin-top: 30%;">speaker_notes</i>';

        buttonDrawNoteGeometryEditorToolContainer.appendChild(buttonDrawNoteGeometryEditorToolContent);
        buttonDrawNoteGeometryEditorTool.appendChild(buttonDrawNoteGeometryEditorToolContainer);

        /**
         * Draw note handle
         */
        const handlebuttonDrawNoteGeometryEditorTool = function () {

            if (geoEditor._hashActiveTool.geometryEditorToolSelect && this == geoEditor._hashActiveTool.geometryEditorToolSelect.node) {

                if (!(typeof geoEditor._mapSgs.map.listeners_.click === 'undefined')) {
                    if (geoEditor._mapSgs.map.listeners_.click.length > 0) {
                        geoEditor._mapSgs.map.listeners_.click = new Array();
                    }
                }

                geoEditor._ActiveSelectTool(geoEditor._hashActiveTool.geometryEditorToolSelect.node, false);

                geoEditor._hashActiveTool.geometryEditorToolSelect = {}

            } else {

                geoEditor.MENU.SELECTED = geoEditor.MENU.EDIT_FEATURE;

                // Desactive select tool if active
                if (geoEditor._hashActiveTool.geometryEditorToolSelect && geoEditor._hashActiveTool.geometryEditorToolSelect.active)
                    geoEditor._ActiveSelectTool(geoEditor._hashActiveTool.geometryEditorToolSelect.node, false);

                geoEditor._mapSgs._utility.HoldButtonEffect('menubar-bottom-geometry-editor-tool', 'target-gpi-eg-draw-note');
                //geoEditor._mapSgs._utility.RemoveActiveButtonInMenu('menubar-bottom-geometry-editor-tool', 'target-gpi-eg-draw-note');

                if ($(this).hasClass('active'))
                    geoEditor._ActicePoliceDrawTool(this, false);
                else
                    geoEditor._ActicePoliceDrawTool(this, true);

                // Register active tool
                geoEditor._hashActiveTool.geometryEditorToolSelect = {
                    active: $(this).hasClass('active'),
                    node: this
                }

                if (!(typeof geoEditor._mapSgs.map.listeners_.click === 'undefined')) {
                    if (geoEditor._mapSgs.map.listeners_.click.length > 0) {
                        geoEditor._mapSgs.map.listeners_.click = new Array();
                    }
                }

                geoEditor.removeInteractions();

                geoEditor._mapSgs.map.on('click', function (evt) {
                    geoEditor.addComment(evt);
                    $('#id-icon-change-load').removeClass('ol-hidden');
                });
            }
        };

        buttonDrawNoteGeometryEditorTool.addEventListener('click', handlebuttonDrawNoteGeometryEditorTool, false);
        
        
        // -- remove draw -------------------------------------------------------------

        const buttonRemoveDrawGeometryEditorTool = document.createElement('li');
        buttonRemoveDrawGeometryEditorTool.className = "border-left";


        const buttonRemoveDrawGeometryEditorToolContainer = document.createElement('a');
        buttonRemoveDrawGeometryEditorToolContainer.setAttribute('href', '#target-gpi-eg-remove-draw');
        buttonRemoveDrawGeometryEditorToolContainer.id = 'target-gpi-eg-remove-draw';
        buttonRemoveDrawGeometryEditorToolContainer.className = 'target';
        buttonRemoveDrawGeometryEditorToolContainer.setAttribute('title', 'Apagar');

        const buttonRemoveDrawGeometryEditorToolContent = document.createElement('div');
        buttonRemoveDrawGeometryEditorToolContent.className = 'menu-icon';
        buttonRemoveDrawGeometryEditorToolContent.innerHTML = '<i class="fa fa-eraser" style="margin-top: 30%;"></i>';

        buttonRemoveDrawGeometryEditorToolContainer.appendChild(buttonRemoveDrawGeometryEditorToolContent);
        buttonRemoveDrawGeometryEditorTool.appendChild(buttonRemoveDrawGeometryEditorToolContainer);

        /**
         * remove draw handle
         */
        const handlebuttonRemoveDrawGeometryEditorTool = function () {

            if (geoEditor._hashActiveTool.geometryEditorToolSelect && this == geoEditor._hashActiveTool.geometryEditorToolSelect.node) {

                geoEditor._ActiveSelectTool(geoEditor._hashActiveTool.geometryEditorToolSelect.node, false);

                if (!(typeof geoEditor._mapSgs.map.listeners_.click === 'undefined')) {
                    if (geoEditor._mapSgs.map.listeners_.click.length > 0) {
                        geoEditor._mapSgs.map.listeners_.click = new Array();
                    }
                }

                geoEditor._hashActiveTool.geometryEditorToolSelect = {}

                geoEditor.MENU.SELECTED = null;

            } else {

                // Desactive select tool if active
                if (geoEditor._hashActiveTool.geometryEditorToolSelect && geoEditor._hashActiveTool.geometryEditorToolSelect.active)
                    geoEditor._ActiveSelectTool(geoEditor._hashActiveTool.geometryEditorToolSelect.node, false);

                geoEditor._mapSgs._utility.HoldButtonEffect('menubar-bottom-geometry-editor-tool', 'target-gpi-eg-remove-draw');
                //geoEditor._mapSgs._utility.RemoveActiveButtonInMenu('menubar-bottom-geometry-editor-tool', 'target-gpi-eg-remove-draw');


                if ($(this).hasClass('active'))
                    geoEditor._ActicePoliceDrawTool(this, false);
                else
                    geoEditor._ActicePoliceDrawTool(this, true);

                // Register active tool
                geoEditor._hashActiveTool.geometryEditorToolSelect = {
                    active: $(this).hasClass('active'),
                    node: this
                }

                geoEditor._mapSgs.map.listeners_.click = new Array();

                geoEditor.MENU.SELECTED = geoEditor.MENU.DELETE_FEATURE;
                geoEditor.removeInteractions();

                if (!(typeof geoEditor._mapSgs.map.listeners_.click === 'undefined')) {
                    if (geoEditor._mapSgs.map.listeners_.click.length > 0) {
                        geoEditor._mapSgs.map.listeners_.click = new Array();
                    }
                }

                geoEditor._mapSgs.map.on('click', function (evt) {
                    this.forEachFeatureAtPixel(evt.pixel,
                        function (feature, layer) {
                            if (layer == null) {
                                return;
                            }
                            if (layer.getSource() == null) {
                                return;
                            }
                            layer.getSource().removeFeature(feature);
                            $('#id-icon-change-load').removeClass('ol-hidden');
                            return true;
                        });
                });

            }

        };

        buttonRemoveDrawGeometryEditorTool.addEventListener('click', handlebuttonRemoveDrawGeometryEditorTool, false);
        
        
        // -- Modify draw -------------------------------------------------------------

        const buttonModifyDrawGeometryEditorTool = document.createElement('li');
        buttonModifyDrawGeometryEditorTool.className = "border-left";


        const buttonModifyDrawGeometryEditorToolContainerContainer = document.createElement('a');
        buttonModifyDrawGeometryEditorToolContainerContainer.setAttribute('href', '#target-gpi-eg-modify-draw');
        buttonModifyDrawGeometryEditorToolContainerContainer.id = 'target-gpi-eg-modify-draw';
        buttonModifyDrawGeometryEditorToolContainerContainer.className = 'target';
        buttonModifyDrawGeometryEditorToolContainerContainer.setAttribute('title', 'Modificar');

        const buttonModifyDrawGeometryEditorToolContent = document.createElement('div');
        buttonModifyDrawGeometryEditorToolContent.className = 'menu-icon';
        buttonModifyDrawGeometryEditorToolContent.innerHTML = '<i class="fa fa-pencil-square-o" style="margin-top: 30%;"></i>';

        buttonModifyDrawGeometryEditorToolContainerContainer.appendChild(buttonModifyDrawGeometryEditorToolContent);
        buttonModifyDrawGeometryEditorTool.appendChild(buttonModifyDrawGeometryEditorToolContainerContainer);

        /**
         * Modify draw handle
         */
        const handlebuttonModifyDrawGeometryEditorTool = function () {
            // Desactive select tool if active
            if (geoEditor._hashActiveTool.policeToolSelect && geoEditor._hashActiveTool.policeToolSelect.active)
                geoEditor._mapSgs._ActiveSelectTool(geoEditor._hashActiveTool.policeToolSelect.node, false);

            // Desactive select by polygon tool if active
            if (geoEditor._hashActiveTool.policeToolSelectByPolygon && geoEditor._hashActiveTool.policeToolSelectByPolygon.active)
                geoEditor._ActiveSelectPoliceNumberByPolygonTool(geoEditor._hashActiveTool.policeToolSelectByPolygon.node, false);

            geoEditor._mapSgs._utility.HoldButtonEffect('menubar-bottom-road-builder-tool', 'target-gpi-draw-police-number');
            //geoEditor._mapSgs._utility.RemoveActiveButtonInMenu('main-menu-road-builder-tool', 'target-gpi-draw-police-number');

            if ($(this).hasClass('active'))
                geoEditor._ActicePoliceDrawTool(this, false);
            else
                geoEditor._ActicePoliceDrawTool(this, true);

            // Register active tool
            geoEditor._hashActiveTool.drawPoliceNumber = {
                active: $(this).hasClass('active'),
                node: this
            }

            geoEditor.MENU.SELECTED = geoEditor.MENU.MODIFY_FEATURE;
            geoEditor.removeInteractions();
            if (!(typeof geoEditor._mapSgs.map.listeners_.click == 'undefined')) {
                if (geoEditor._mapSgs.map.listeners_.click.length > 0) {
                    geoEditor._mapSgs.map.listeners_.click = new Array();
                }
            }

            geoEditor.modifyTool = new Modify(
                {
                    source: geoEditor.vectorSource,
                    insertVertexCondition: function (event) {
                        return true;
                    },
                    condition: function (event) {

                        return true;
                    }
                });


            geoEditor.modifyTool.on('modifystart', function (event) {

            });

            geoEditor.modifyTool.on('modifyend', function (event) {
                const modifyFeatures = event.features.array_;
                let modifiedFeature = null;
                for (let i = 0; i < modifyFeatures.length; i++) {
                    const f = modifyFeatures[i];
                    if (geoEditor.REVISION_STORE[f.getId().toString()] != f.getRevision()) {
                        geoEditor.REVISION_STORE[f.getId().toString()] = f.getRevision();
                        modifiedFeature = f;
                        break;
                    }
                }
                $('#id-icon-change-load').removeClass('ol-hidden');
            });

            geoEditor._mapSgs.map.addInteraction(geoEditor.modifyTool);
            if (geoEditor.MENU.SNAP) {
                geoEditor.snapTool = new Snap({ source: geoEditor.vectorSource });
                geoEditor._mapSgs.map.addInteraction(geoEditor.snapTool);
            } else {
                geoEditor._mapSgs.map.removeInteraction(geoEditor.snapTool);
            }

        };

        buttonModifyDrawGeometryEditorTool.addEventListener('click', handlebuttonModifyDrawGeometryEditorTool, false);
        
        
        // -- Snapping draw -------------------------------------------------------------

        const buttonSnappingGeometryEditorTool = document.createElement('li');

        const buttonSnappingGeometryEditorToolContainer = document.createElement('a');
        buttonSnappingGeometryEditorToolContainer.setAttribute('href', '#target-gpi-eg-snapping');
        buttonSnappingGeometryEditorToolContainer.id = 'target-gpi-eg-snapping';
        buttonSnappingGeometryEditorToolContainer.className = 'target';
        buttonSnappingGeometryEditorToolContainer.setAttribute('title', 'Snapping');

        const buttonSnappingGeometryEditorToolContent = document.createElement('div');
        buttonSnappingGeometryEditorToolContent.className = 'menu-icon';
        buttonSnappingGeometryEditorToolContent.innerHTML = '<i class="gpi gpi-snapping"></i>';

        buttonSnappingGeometryEditorToolContainer.appendChild(buttonSnappingGeometryEditorToolContent);
        buttonSnappingGeometryEditorTool.appendChild(buttonSnappingGeometryEditorToolContainer);

        /**
         * snapping handle
         */
        const handlebuttonSnappingGeometryEditorTool = function () {
            // Desactive select tool if active
            if (geoEditor._hashActiveTool.policeToolSelect && geoEditor._hashActiveTool.policeToolSelect.active)
                geoEditor._mapSgs._ActiveSelectTool(geoEditor._hashActiveTool.policeToolSelect.node, false);

            // Desactive select by polygon tool if active
            if (geoEditor._hashActiveTool.policeToolSelectByPolygon && geoEditor._hashActiveTool.policeToolSelectByPolygon.active)
                geoEditor._ActiveSelectPoliceNumberByPolygonTool(geoEditor._hashActiveTool.policeToolSelectByPolygon.node, false);

            geoEditor._mapSgs._utility.HoldButtonEffect('menubar-bottom-road-builder-tool', 'target-gpi-draw-police-number');
            //geoEditor._mapSgs._utility.RemoveActiveButtonInMenu('main-menu-road-builder-tool', 'target-gpi-draw-police-number');

            if ($(this).hasClass('active'))
                geoEditor._ActicePoliceDrawTool(this, false);
            else
                geoEditor._ActicePoliceDrawTool(this, true);

            // Register active tool
            geoEditor._hashActiveTool.drawPoliceNumber = {
                active: $(this).hasClass('active'),
                node: this
            }

            geoEditor.MENU.SNAP = !geoEditor.MENU.SNAP;
            if (geoEditor.MENU.SNAP) {
                geoEditor.snapTool = new Snap({ source: geoEditor.vectorSource });
                geoEditor._mapSgs.map.addInteraction(geoEditor.snapTool);
            } else {
                geoEditor._mapSgs.map.removeInteraction(geoEditor.snapTool);
            }


        };

        buttonSnappingGeometryEditorTool.addEventListener('click', handlebuttonSnappingGeometryEditorTool, false);
        
        
        
        // -- clean all draw -------------------------------------------------------------

        const buttonCleanDrawGeometryEditorTool = document.createElement('li');


        const buttonCleanDrawGeometryEditorToolContainer = document.createElement('a');
        buttonCleanDrawGeometryEditorToolContainer.setAttribute('href', '#target-gpi-eg-clean-draw');
        buttonCleanDrawGeometryEditorToolContainer.id = 'target-gpi-eg-clean-line';
        buttonCleanDrawGeometryEditorToolContainer.className = 'target';
        buttonCleanDrawGeometryEditorToolContainer.setAttribute('title', 'Limpar');

        const buttonCleanDrawGeometryEditorToolContent = document.createElement('div');
        buttonCleanDrawGeometryEditorToolContent.className = 'menu-icon';
        buttonCleanDrawGeometryEditorToolContent.innerHTML = '<i class="gpi gpi-apagar"></i>';

        buttonCleanDrawGeometryEditorToolContainer.appendChild(buttonCleanDrawGeometryEditorToolContent);
        buttonCleanDrawGeometryEditorTool.appendChild(buttonCleanDrawGeometryEditorToolContainer);

        /**
         *  clean all draw handle
         */
        const handlebuttonCleanDrawGeometryEditorTool = function () {

            geoEditor._CleanAllAnnotation();

        };

        buttonCleanDrawGeometryEditorTool.addEventListener('click', handlebuttonCleanDrawGeometryEditorTool, false);
        
        
        
        // -- Save draw -------------------------------------------------------------

        const buttonSaveDrawGeometryEditorTool = document.createElement('li');

        const buttonSavenDrawGeometryEditorToolContainer = document.createElement('a');
        buttonSavenDrawGeometryEditorToolContainer.setAttribute('href', '#target-gpi-eg-save-draw');
        buttonSavenDrawGeometryEditorToolContainer.id = 'target-gpi-eg-save-line';
        buttonSavenDrawGeometryEditorToolContainer.className = 'target';
        buttonSavenDrawGeometryEditorToolContainer.setAttribute('title', 'Guardar');

        const buttonSaveDrawGeometryEditorToolContent = document.createElement('div');
        buttonSaveDrawGeometryEditorToolContent.className = 'menu-icon';
        buttonSaveDrawGeometryEditorToolContent.innerHTML = '<i class="fa fa-floppy-o" style="margin-top: 30%;"></i>';

        const buttonSaveIconDrawGeometryEditorToolContent = document.createElement('div');
        buttonSaveIconDrawGeometryEditorToolContent.className = 'menu-icon';
        buttonSaveIconDrawGeometryEditorToolContent.innerHTML = '<i id="id-icon-change-load" class="ol-hidden fa fa-circle dot-edit-load"></i>';

        buttonSavenDrawGeometryEditorToolContainer.appendChild(buttonSaveDrawGeometryEditorToolContent);
        buttonSavenDrawGeometryEditorToolContainer.appendChild(buttonSaveIconDrawGeometryEditorToolContent);
        buttonSaveDrawGeometryEditorTool.appendChild(buttonSavenDrawGeometryEditorToolContainer);

        /**
         * Save draw handle
         */
        const handlebuttonSaveDrawGeometryEditorTool = function () {

            var featuresData = geoEditor._geojsonFormat.writeFeatures(geoEditor.layer.getSource().getFeatures())

            if (geoEditor._IdFeatureDataSelect) {

                var _formDataSearchAnacom = {}

                _formDataSearchAnacom.geojson = featuresData;

                _formDataSearchAnacom.id = geoEditor._IdFeatureDataSelect;

                _formDataSearchAnacom.idUser = geoEditor._mapSgs._settings.userInfo.userId

                _formDataSearchAnacom.idUser = geoEditor._mapSgs._settings.userInfo.userId

                var CommentObject = {};

                $.each(geoEditor._hashComment, function (key, value) {

                    if ($('#' + value.id).html() != null && $('#' + value.id).html() != "") {

                        geoEditor._hashComment[key].text = $('#' + value.id).html();

                        CommentObject[key] = geoEditor._hashComment[key];

                    }


                });

                _formDataSearchAnacom.Overlay = JSON.stringify(CommentObject);

                $.ajax({
                    type: 'POST',
                    url: '/rest/app/Service/SaveMapAnnotation?userID=' + geoEditor._mapSgs._settings.userInfo.userId,
                    data: JSON.stringify(_formDataSearchAnacom),
                    contentType: "application/json",
                    success: function (data) {

                        if(data.result === "NotUser") {

                            toastr.options.timeOut = "5000";
                            var warning = toastr["warning"]("Apenas o utilizador que cria a anotação pode editar a mesma");
                            toastr.options.timeOut = "2000";
                            return warning

                        }


                        if ($('#id-map-title-geometry-load').length > 0) {

                            $('#id-map-title-geometry-load').css('display', 'block');
                            $('#id-map-title-geometry-load')[0].innerHTML = 'Anotação carregada: ' + $('#id-modal-geometry-editor-tool-name').val();

                        } else if ($('#id-map-title-geometry-load').length == 0) {

                            $('#map').append('<div id="id-map-title-geometry-load" class="div-name-geometry-editor-load active">Anotação carregada: ' + $('#id-modal-geometry-editor-tool-name').val() + '</div>')

                        }

                        if (geoEditor._mapSgs._utility.mobilecheck()) {
                            $('.div-name-geometry-editor-load').css('bottom', '130px');
                        }

                        $('#id-icon-change-load').addClass('ol-hidden');

                        $('#id-buttoneg-delete-load').removeClass('hide-delete-button');

                        $('#id-modal-geometry-editor-tool').modal('hide');

                        toastr["success"]("Gravação realizada com sucesso");

                    },
                    error: function (request, status, error) {
                        toastr["error"]("Erro na gravação");
                        myMapSgs._utility.ShowWait('offcanvas-entity-form-spinner', false);
                    }
                });

            } else {

                if ($('#id-map-title-geometry-load').length == 0) {

                    $('#id-modal-geometry-editor-tool-name').val('');

                    $('#id-modal-geometry-editor-tool-description').val('');

                }

                geoEditor._GetAllAnnotations('id-geometry-editor-tool-save-datatable', this, 'id-modal-geometry-editor-tool', true);

            }


        };

        buttonSaveDrawGeometryEditorTool.addEventListener('click', handlebuttonSaveDrawGeometryEditorTool, false);
        
        // -- Save as draw -------------------------------------------------------------

        const buttonSaveAsDrawGeometryEditorTool = document.createElement('li');

        const buttonSaveAsDrawGeometryEditorToolContainer = document.createElement('a');
        buttonSaveAsDrawGeometryEditorToolContainer.setAttribute('href', '#target-gpi-eg-save-as-draw');
        buttonSaveAsDrawGeometryEditorToolContainer.id = 'target-gpi-eg-save-as-draw';
        buttonSaveAsDrawGeometryEditorToolContainer.className = 'target';
        buttonSaveAsDrawGeometryEditorToolContainer.setAttribute('title', 'Guardar como');

        const buttonSaveAsDrawGeometryEditorToolContent = document.createElement('div');
        buttonSaveAsDrawGeometryEditorToolContent.className = 'menu-icon';
        buttonSaveAsDrawGeometryEditorToolContent.innerHTML = '<i class="fa fa-floppy-o" style="margin-top: 30%;"></i>';

        const buttonSavePencilAsDrawGeometryEditorToolContent = document.createElement('div');
        buttonSavePencilAsDrawGeometryEditorToolContent.className = 'menu-icon';
        buttonSavePencilAsDrawGeometryEditorToolContent.innerHTML = '<i class="pencil-save-as fa fa-pencil"></i>';

        buttonSaveAsDrawGeometryEditorToolContainer.appendChild(buttonSaveAsDrawGeometryEditorToolContent);
        buttonSaveAsDrawGeometryEditorToolContainer.appendChild(buttonSavePencilAsDrawGeometryEditorToolContent);
        buttonSaveAsDrawGeometryEditorTool.appendChild(buttonSaveAsDrawGeometryEditorToolContainer);

        /**
         * Save as draw handle
         */
        var handlebuttonSaveAsDrawGeometryEditorTool = function () {

            if ($('#id-map-title-geometry-load').length == 0) {

                $('#id-modal-geometry-editor-tool-name').val('');

                $('#id-modal-geometry-editor-tool-description').val('');

            }

            geoEditor._GetAllAnnotations('id-geometry-editor-tool-save-datatable', this, 'id-modal-geometry-editor-tool', true);

        };

        buttonSaveAsDrawGeometryEditorTool.addEventListener('click', handlebuttonSaveAsDrawGeometryEditorTool, false);
        
        // -- Load draw -------------------------------------------------------------

        const buttonLoadDrawGeometryEditorTool = document.createElement('li');

        const buttonLoadDrawGeometryEditorToolContainer = document.createElement('a');
        buttonLoadDrawGeometryEditorToolContainer.setAttribute('href', '#target-gpi-eg-load-draw');
        buttonLoadDrawGeometryEditorToolContainer.id = 'target-gpi-eg-load-line';
        buttonLoadDrawGeometryEditorToolContainer.className = 'target';
        buttonLoadDrawGeometryEditorToolContainer.setAttribute('title', 'Carregar');

        const buttonLoadDrawGeometryEditorToolContent = document.createElement('div');
        buttonLoadDrawGeometryEditorToolContent.className = 'menu-icon';
        buttonLoadDrawGeometryEditorToolContent.innerHTML = '<i class="fa fa-cloud-download" style="margin-top: 30%;"></i>';

        buttonLoadDrawGeometryEditorToolContainer.appendChild(buttonLoadDrawGeometryEditorToolContent);
        buttonLoadDrawGeometryEditorTool.appendChild(buttonLoadDrawGeometryEditorToolContainer);

        /**
         * Load draw handle
         */
        const handlebuttonLoadDrawGeometryEditorTool = function () {

            geoEditor._GetAllAnnotations('id-geometry-editor-tool-load-datatable', this, 'id-modal-geometry-editor-tool-load',true);

        };

        buttonLoadDrawGeometryEditorTool.addEventListener('click', handlebuttonLoadDrawGeometryEditorTool, false);
        
        
        
        // -- Visible draw -------------------------------------------------------------

        const buttonVisibleDrawGeometryEditorTool = document.createElement('li');

        const buttonVisibleDrawGeometryEditorToolContainer = document.createElement('a');
        buttonVisibleDrawGeometryEditorToolContainer.setAttribute('href', '#target-gpi-eg-visible-draw');
        buttonVisibleDrawGeometryEditorToolContainer.id = 'target-gpi-eg-visible-line';
        buttonVisibleDrawGeometryEditorToolContainer.className = 'target';
        buttonVisibleDrawGeometryEditorToolContainer.setAttribute('title', 'Visível');

        const buttonVisibleDrawGeometryEditorToolContent = document.createElement('div');
        buttonVisibleDrawGeometryEditorToolContent.className = 'menu-icon';
        buttonVisibleDrawGeometryEditorToolContent.innerHTML = '<i class="fa fa-eye" style="margin-top: 30%;"></i>';

        buttonVisibleDrawGeometryEditorToolContainer.appendChild(buttonVisibleDrawGeometryEditorToolContent);
        buttonVisibleDrawGeometryEditorTool.appendChild(buttonVisibleDrawGeometryEditorToolContainer);

        /**
         * Visible draw handle
         */
        const handlebuttonVisibleDrawGeometryEditorTool = function () {

            if ($(this).find('i').hasClass('fa-eye-slash')) {

                geoEditor.layer.setVisible(true);
                $(this).find('i').removeClass('fa-eye-slash').addClass('fa-eye');

                $.each(geoEditor._hashComment, function (key, value) {

                    $('#' + value.id).css({ 'display': 'block' });

                });

            } else if ($(this).find('i').hasClass('fa-eye')) {

                geoEditor.layer.setVisible(false);
                $(this).find('i').removeClass('fa-eye').addClass('fa-eye-slash');

                $.each(geoEditor._hashComment, function (key, value) {

                    $('#' + value.id).css({ 'display': 'none' });

                });

            }
            

        };

        buttonVisibleDrawGeometryEditorTool.addEventListener('click', handlebuttonVisibleDrawGeometryEditorTool, false);
        
        
        
        // -- Delete draw -------------------------------------------------------------

        const buttonDeleteDrawGeometryEditorTool = document.createElement('li');
        buttonDeleteDrawGeometryEditorTool.id = "id-buttoneg-delete-load";
        buttonDeleteDrawGeometryEditorTool.className = "border-left hide-delete-button";

        const buttonDeleteDrawGeometryEditorToolContainer = document.createElement('a');
        buttonDeleteDrawGeometryEditorToolContainer.setAttribute('href', '#target-gpi-eg-delete-load');
        buttonDeleteDrawGeometryEditorToolContainer.id = 'target-gpi-eg-delete-load';
        buttonDeleteDrawGeometryEditorToolContainer.className = 'target';
        buttonDeleteDrawGeometryEditorToolContainer.setAttribute('title', 'Eliminar');

        const buttonDeleteDrawGeometryEditorToolContent = document.createElement('div');
        buttonDeleteDrawGeometryEditorToolContent.className = 'menu-icon';
        buttonDeleteDrawGeometryEditorToolContent.innerHTML = '<i class="fa fa-trash-o" style="margin-top: 30%;"></i>';

        buttonDeleteDrawGeometryEditorToolContainer.appendChild(buttonDeleteDrawGeometryEditorToolContent);
        buttonDeleteDrawGeometryEditorTool.appendChild(buttonDeleteDrawGeometryEditorToolContainer);

        /**
         * Close draw handle
         */
        const handlebuttonDeleteDrawGeometryEditorTool = function () {

            var remove = confirm("Tem a certeza?");

            if (remove) {

                $.ajax({
                    type: 'DELETE',
                    url: '/rest/app/Service/DeleteMapAnnotation?id=' + geoEditor._IdFeatureDataSelect + "&userId=" + geoEditor._mapSgs._settings.userInfo.userId,
                    contentType: "application/json",
                    success: function (data) {

                        if (data.result === "Success") {

                            if ($('#id-map-title-geometry-load').length > 0) {

                                $('#id-map-title-geometry-load').css('display', 'block');
                                $('#id-map-title-geometry-load')[0].innerHTML = 'Anotação carregada: ' + $('#id-modal-geometry-editor-tool-name').val();

                            } else if ($('#id-map-title-geometry-load').length == 0) {

                                $('#map').append('<div id="id-map-title-geometry-load" class="div-name-geometry-editor-load active">Anotação carregada: ' + $('#id-modal-geometry-editor-tool-name').val() + '</div>')

                            }

                            if (geoEditor._mapSgs._utility.mobilecheck()) {
                                $('.div-name-geometry-editor-load').css('bottom', '130px');
                            }

                            $('#id-icon-change-load').addClass('ol-hidden');

                            $('#id-modal-geometry-editor-tool').modal('hide');

                            geoEditor._CleanAllAnnotation();

                            toastr["success"]("Eliminação realizada com sucesso");

                        } else if (data.result === "NotUser") {

                            toastr.options.timeOut = "5000";
                            var warning = toastr["warning"]("Apenas o utilizador que cria a anotação pode eliminar a mesma");
                            toastr.options.timeOut = "2000";
                            return warning

                        }

                    },
                    error: function (request, status, error) {
                        toastr["error"]("Erro na gravação");
                        myMapSgs._utility.ShowWait('offcanvas-entity-form-spinner', false);
                    }
                });

            }

            

        };

        buttonDeleteDrawGeometryEditorTool.addEventListener('click', handlebuttonDeleteDrawGeometryEditorTool, false);
        
        
        
        // -- Close draw -------------------------------------------------------------

        const buttonCloseDrawGeometryEditorTool = document.createElement('li');
        buttonCloseDrawGeometryEditorTool.className = "border-left";

        const buttonCloseDrawGeometryEditorToolContainer = document.createElement('a');
        buttonCloseDrawGeometryEditorToolContainer.setAttribute('href', '#target-gpi-eg-close-draw');
        buttonCloseDrawGeometryEditorToolContainer.id = 'target-gpi-eg-close-line';
        buttonCloseDrawGeometryEditorToolContainer.className = 'target';
        buttonCloseDrawGeometryEditorToolContainer.setAttribute('title', 'Fechar');

        const buttonCloseDrawGeometryEditorToolContent = document.createElement('div');
        buttonCloseDrawGeometryEditorToolContent.className = 'menu-icon';
        buttonCloseDrawGeometryEditorToolContent.innerHTML = '<i class="fa fa-times" style="margin-top: 30%;"></i>';

        buttonCloseDrawGeometryEditorToolContainer.appendChild(buttonCloseDrawGeometryEditorToolContent);
        buttonCloseDrawGeometryEditorTool.appendChild(buttonCloseDrawGeometryEditorToolContainer);

        /**
         * Close draw handle
         */
        const handlebuttonCloseDrawGeometryEditorTool = function () {
            $('#button-open-geometry-editor-tool').trigger('click');
        };

        buttonCloseDrawGeometryEditorTool.addEventListener('click', handlebuttonCloseDrawGeometryEditorTool, false);

        

        

        // --------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
        // -- Build Menu ------------------------------------------------------------------------------------------------------------------------------------------------------------------
        // --------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

        // -- Main menu bar road builder tool -------------------------------------------------
        const mainMenuGeometryEditorTool = document.createElement('ul');
        mainMenuGeometryEditorTool.id = 'main-menu-geometry-editor-tool';
        mainMenuGeometryEditorTool.className = 'map-controls menubar-bottom';
        
        mainMenuGeometryEditorTool.appendChild(buttonDrawPointGeometryEditorTool);
        mainMenuGeometryEditorTool.appendChild(buttonDrawPolygonGeometryEditorTool);
        mainMenuGeometryEditorTool.appendChild(buttonDrawLineGeometryEditorTool);
        mainMenuGeometryEditorTool.appendChild(buttonDrawNoteGeometryEditorTool);
        mainMenuGeometryEditorTool.appendChild(buttonModifyDrawGeometryEditorTool);
        mainMenuGeometryEditorTool.appendChild(buttonSnappingGeometryEditorTool);
        mainMenuGeometryEditorTool.appendChild(buttonRemoveDrawGeometryEditorTool);
        mainMenuGeometryEditorTool.appendChild(buttonCleanDrawGeometryEditorTool);
        mainMenuGeometryEditorTool.appendChild(buttonSaveDrawGeometryEditorTool);
        mainMenuGeometryEditorTool.appendChild(buttonSaveAsDrawGeometryEditorTool);
        mainMenuGeometryEditorTool.appendChild(buttonLoadDrawGeometryEditorTool);
        mainMenuGeometryEditorTool.appendChild(buttonVisibleDrawGeometryEditorTool);
        mainMenuGeometryEditorTool.appendChild(buttonDeleteDrawGeometryEditorTool);
        mainMenuGeometryEditorTool.appendChild(buttonCloseDrawGeometryEditorTool);
        

        // -- Menu panel road builder tool ----------------------------------------------------
        const menuPanelGeometryEditorTool = document.createElement('div');
        menuPanelGeometryEditorTool.appendChild(mainMenuGeometryEditorTool);

        return menuPanelGeometryEditorTool;
    }

    /**
     * Active select tool
     * @param {dom} element, node element of the button (li)
     * @param {boolean} active, true active tool otherwise desactive
     * @param {dom} nextElement, next node to be active
     */
    this._ActiveSelectTool = function (element, active, nextElement) {
        // Desactive tool
        if (!active) {

            $(element).removeClass('active');
            $(element).find('a').removeClass('hold-button');
            $(element).find('a').removeClass('target');

            // Reset event layer tooltips
            if (geoEditor._mapSgs.tooltips)
                geoEditor._mapSgs.map.on('singleclick', async (e) => { await geoEditor._mapSgs.tooltips.BuildInfoTooltips(e); });

            // Reset cursor
            document.body.style.cursor = 'default';
            
        }
        else {

            // Active tool
            $(element).addClass('active');

            // Set selection 
            geoEditor._ActiveSelectRoad();

            // Remove event layer tooltips
            if (geoEditor._mapSgs.tooltips)
                geoEditor._mapSgs.map.un('singleclick', geoEditor._mapSgs.tooltips.BuildInfoTooltips);

            // Change cursor
            document.body.style.cursor = 'crosshair';

            
        }

        // Register active tool
        geoEditor._hashActiveTool.geometryEditorToolSelect = {
            active: active,
            node: element
        }
    }

    this._GetAllAnnotations = function (idDatatable, button, idModal, eventSelect) {

        var ClassList = $(button).find('i')[0].className;

        $($(button).find('i')[0]).removeClass(ClassList).addClass('fa fas fa-spinner fa-spin');

        $.ajax({
            type: 'GET',
            url: '/rest/app/Service/GetMapAnnotation',
            contentType: "application/json",
            success: function (data) {
                if (data.result.length > 0) {

                    geoEditor.createDatatable(idDatatable);

                    geoEditor._DatatableResultAnnotation.clear();

                    geoEditor._DatatableResultAnnotation.rows.add(data.result);

                    geoEditor._DatatableResultAnnotation.draw();

                    if (eventSelect) {

                        geoEditor._DatatableResultAnnotation.on('select', function (e, dt, type, indexes) {
                            if (type === 'row') {
                                
                                var data = geoEditor._DatatableResultAnnotation.rows('.selected').data();

                                $('#id-modal-geometry-editor-tool-name').val(data[0].name);

                                $('#id-modal-geometry-editor-tool-description').val(data[0].observation);

                            }
                        });

                    }

                    $($(button).find('i')[0]).removeClass('fa fas fa-spinner fa-spin').addClass(ClassList); 

                    $('#' + idModal).modal('show');

                } else {

                    if (geoEditor._DatatableResultAnnotation)
                        geoEditor._DatatableResultAnnotation.clear().draw();

                    toastr["warning"]("Nenhuma anotação encontrada");

                    $($(button).find('i')[0]).removeClass('fa fas fa-spinner fa-spin').addClass(ClassList); 

                    $('#' + idModal).modal('show');

                }


            },
            error: function (request, status, error) {
                toastr["error"]("Erro na gravação");

                $($(button).find('i')[0]).removeClass('fa fas fa-spinner fa-spin').addClass(ClassList); 

            }
        });

    }

    /**
     * Clean All Annotations
     * */
    this._CleanAllAnnotation = function () {

        var features = geoEditor.layer.getSource().getFeatures();
        features.forEach((feature) => {
            geoEditor.layer.getSource().removeFeature(feature);
        });

        geoEditor.removeInteractions();

        // Reset cursor
        document.body.style.cursor = 'default';

        $.each(geoEditor._hashComment, function (key, value) {

            $('#' + value.id).remove();

        });

        geoEditor.overlayId = 0;

        geoEditor._hashComment = {};

        // Active tooltip
        if (geoEditor._mapSgs.tooltips)
            geoEditor._mapSgs.map.on('singleclick', async (e) => { await geoEditor._mapSgs.tooltips.BuildInfoTooltips(e); });


        // Close road build tool
        $('#menubar-bottom-road-builder-tool').toggle('ol-hidden');

        $('#id-menubar-bottom-geometry-editor-tool li').removeClass('active');

        $('#id-menubar-bottom-geometry-editor-tool a').removeClass('hold-button');

        geoEditor._mapSgs.map.listeners_.click = new Array();

        $('#id-map-title-geometry-load').remove();

        $('#id-buttoneg-delete-load').addClass('hide-delete-button');

        $('#id-icon-change-load').addClass('ol-hidden');

        geoEditor._IdFeatureDataSelect = null;

    }

    // -- begin private variable ------------------------------------------------------------------
    // -- end event -------------------------------------------------------------------------------
};

/**
 * Init map street view information
 * @param {ol.map} map, ol map
 */
GeometryEditorTool.prototype.Init = function (MapSgs) {

    // Keep map sgs
    this._mapSgs = MapSgs;
    this.initialize();
};

